export const elements = {
    apple: { type: 'item', key: 'apple', position: [0,0,0], rotation: [0.0,0.0,0], scale: [0.015,0.015,0.015], data:{ type : 'food', food : 1, drink: 1}},
    soda: { type: 'item', key: 'soda', position: [0,0,0], rotation: [20.0,0.0,0], scale: [0.02,0.02,0.02], data:{}},
    hotdog: { type: 'item', key: 'hotdog', position: [0,0,0], rotation: [20.0,0.0,0], scale: [0.02,0.02,0.02], data:{}},
};